import { get, put, post, remove } from './API'
import * as constants from '../../mixins/constants'

export const getOrderFormPublic = (params) => {
  const uri = constants.API.draft_order.orderFormPublic + params
  return get(uri, {}, { token_required: false })
}

export const createDraftOrderPublic = (params) => {
  const uri = constants.API.draft_order.draftOrderPublic
  return post(uri, params, { token_required: false, stringify_data: false })
}

export const createOrderForm = (params) => {
  const uri = constants.API.draft_order.createOrderForm
  return post(uri, params, { stringify_data: false })
}

export const getOrderFormById = (params) => {
  const uri = constants.API.draft_order.getOrderForm + params.id
  return get(uri, {}, { stringify_data: false })
}

export const updateOrderFormById = (params) => {
  const uri = constants.API.draft_order.getOrderForm + params.id
  return put(uri, params, { stringify_data: false })
}

export const delOrderFormById = (params) => {
  const uri = constants.API.draft_order.getOrderForm + params.id
  return remove(uri, {}, { stringify_data: false })
}

export const getListOrderForm = () => {
  const uri = constants.API.draft_order.getListOrderForm
  return get(uri, {}, { stringify_data: false })
}

export const createDraftOrder = (params) => {
  const uri = constants.API.draft_order.createDraftOrder
  return post(uri, params, { stringify_data: false })
}

export const getDraftOrderById = (params) => {
  const uri = constants.API.draft_order.getDraftOrder + params.id
  return get(uri, {}, { stringify_data: false })
}

export const updateDraftOrderById = (params) => {
  const uri = constants.API.draft_order.getDraftOrder + params.id
  return put(uri, params, { stringify_data: false })
}

export const delDraftOrderById = (params) => {
  const uri = constants.API.draft_order.getDraftOrder + params.id
  return remove(uri, {}, { stringify_data: false })
}

export const getListDraftOrder = (params) => {
  const uri = constants.API.draft_order.getListDraftOrder
  return get(uri, params, { stringify_data: true })
}
